import { LmsUserStatus } from "~/features/lms/types/LmsUserStatus";
import { getSessionUserSnapshot } from "~/domains/user/sessionRuntime";

export function getUserStatus(): LmsUserStatus {
  return (getSessionUserSnapshot().lmsState ?? LmsUserStatus.Guest) as LmsUserStatus;
}
